<template>
  <div class="pagiNation"
>
    <el-row type="flex"
            class=""
            justify="center">
      <el-pagination :page-size.sync="PageSize"
                     background
                     @size-change="handleSizeChange"
                     layout="total, sizes, prev, pager, next, jumper"
                     :page-sizes="page_sizes"
                     :total="Count"
                     @current-change="onCurrentChange"
                     :current-page='currentPage'
                    >
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'pagiNation',
  props: ['Count'],
  data () {
    return {
      currentPage: 1,
      // 个数选择器（可修改）
      page_sizes: [15, 30, 50, 100],
      // 默认每页显示的条数（可修改）
      PageSize: 15,
    }
  },
  computed: {
    show () {
      if (this.Count == 0 || this.Count == undefined) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    handleSizeChange (PageSize) {
      this.PageSize = PageSize
      this.$emit('size-change', this.PageSize)
    },
    onCurrentChange (val) {
      this.currentPage = val
      this.$emit("current-change", this.currentPage)
    },
    tbclick () {
      this.currentPage = 1;
      this.PageSize = 15;
      console.log("cf", this.PageSize, this.currentPage);
    }
  },
  mounted () {
   console.log(this.currentPage);
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 5px;
}
.pagiNation{
  margin-top: 8px;
}
</style>